<template>
  <div class="wrapper">
    <div class="ui-broadcast-mobile" @click="$hideBroadcast()" v-if="isMobile">
      <img class="bg" :src="`${$cdn}images/mobile/default_bg.png`" alt="">
      <img class="back-icon"  @click="$hideBroadcast()" :src="`${$cdn}images/back-icon.png`" alt="">
      <div class="ui-con" @click.stop v-if="link.item.displayModel === 2">
        <div class="img-con">
            <video :src="link.item.video" autoplay loop></video>
        </div>
      </div>
     <div class="full"  @click.stop v-else>
        <iframe :src="link.item.webSite" frameborder="0"></iframe>
        <img class="full-btn"  @click="$hideBroadcast()" :src="`${$cdn}images/close-full.png`" alt="">
      </div>
    </div>

    <div class="ui-broadcast" @click="$hideBroadcast()" v-if="!isMobile">
      <div class="ui-con" @click.stop v-if="link.item.displayModel === 2">
        <div class="img-con img-k">
            <video :src="link.item.video" autoplay loop></video>
        </div>
      </div>
     <div class="full"  @click.stop v-else>
        <iframe :src="link.item.webSite" frameborder="0"></iframe>
        <img class="full-btn"  @click="$hideBroadcast()" :src="`${$cdn}images/close-full.png`" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import browser from "@/utils/browser.js";
export default {
  data(){
    return {
      isMobile: browser.mobile
    };
    
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/css/globalVars.less';

.ui-broadcast{
  width: calc(100% - 200px);
  height: 100%;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  background: rgba(123,63,33,0.5);
  
  .ui-con{
    top: 48%;
    left: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    width: 60%;
    position: relative;
    font-size: 0;
    border: 6px solid @theme;
    box-sizing: border-box;
    iframe,video{
      width: 100%;
      min-height: 550px;
    }
    img{
      width: 100%;
      height: auto;
    }
  }
  .full{
    width: 100%;
    height: 100%;
    z-index: 999;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    iframe{
      width: 100%;
      height: 100%;
    }
    .full-btn{
      width: 50px;
      position: absolute;
      right: 12px;
      top: 30px;
      cursor: pointer;
    }
  }
}

.ui-broadcast-mobile{
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  
  .bg {
    width: 100%;
    height: 100%;
  }
  .back-icon {
    position: fixed;
    top: 20px;
    left: 20px;
  }
  .ui-con{
    top: 48%;
    left: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    width: 100%;
    position: fixed;
    font-size: 0;
    
    box-sizing: border-box;
    iframe,video{
      width: 100%;
      min-height: 550px;
    }
    img{
      width: 100%;
      height: auto;
    }
  }
  .full{
    width: 100%;
    height: 100%;
    z-index: 999;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    iframe{
      width: 100%;
      height: 100%;
    }
    .full-btn{
      width: 50px;
      position: absolute;
      right: 12px;
      top: 30px;
      cursor: pointer;
    }
  }
}
</style>